import { useComputed, useSignal } from "@preact/signals";
import Icon from "$store/components/ui/Icon.tsx";
import Button from "$store/components/ui/Button.tsx";
import { useWishlist } from "apps/vtex/hooks/useWishlist.ts";
import { useUI } from "$store/sdk/useUI.ts";
import { useUser } from "apps/vtex/hooks/useUser.ts";

interface Props {
  productID: string;
  productGroupID?: string;
  customClass?: string;
}

function WishlistButton({
  productID,
  productGroupID,
  customClass = "",
}: Props) {
  const { user } = useUser();
  const { displayToast } = useUI();
  const item = { sku: productID, productId: productGroupID! };
  const { loading, addItem, removeItem, getItem } = useWishlist();
  const listItem = useComputed(() => getItem(item));
  const fetching = useSignal(false);

  const isUserLoggedIn = Boolean(user.value?.email);
  const inWishlist = Boolean(listItem.value);

  return (
    <Button
      class={`w-6 h-6 rounded-full bg-tw-base-50 flex justify-center items-center ${
        inWishlist ? "border border-tw-primary-100" : ""
      } ${customClass}`}
      loading={fetching.value}
      aria-label="Add to wishlist"
      onClick={async (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (!isUserLoggedIn) {
          const { href } = new URL(
            "/login?returnUrl=/wishlist",
            window.location.href,
          );

          window.location.href = href;

          return;
        }

        if (loading.value) {
          return;
        }

        try {
          fetching.value = true;

          if (!inWishlist) {
            await addItem(item);
            displayToast.value = "Produto adicionado aos favoritos!";
          } else {
            await removeItem({ id: listItem.value!.id }!);
            displayToast.value = "Produto removido dos favoritos!";
          }
        } finally {
          fetching.value = false;
        }
      }}
    >
      {inWishlist
        ? (
          <Icon
            id="HeartFilled"
            class="text-tw-primary-100 lg:w-5 lg:h-5"
            width={16}
            height={15}
          />
        )
        : (
          <Icon
            id="Heart"
            class="text-tw-primary-100 lg:w-5 lg:h-5"
            width={16}
            height={15}
          />
        )}
    </Button>
  );
}

export default WishlistButton;
